"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _CommonContentStyleModule = _interopRequireDefault(require("../CommonContentStyle.module.scss"));

var _ClassSkillTooltipContentModule = _interopRequireDefault(require("./ClassSkillTooltipContent.module.scss"));

var _ClassSkillTooltipContent = _interopRequireDefault(require("./ClassSkillTooltipContent.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassSkillTooltipContent = function ClassSkillTooltipContent(_ref) {
  var skill = _ref.skill,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var id = skill.id,
      model = skill.model,
      level = skill.level;
  var modelId = model.id,
      costMana = model.costMana,
      costManaLevelMultiplier = model.costManaLevelMultiplier,
      costStamina = model.costStamina,
      costStaminaLevelMultiplier = model.costStaminaLevelMultiplier;
  var i18nName = model.i18nName;
  var i18nDescription = model.i18nDescription;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentStyleModule.default.content, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CommonContentStyleModule.default.identifiers
  }, "".concat(id || "").concat(modelId && " (".concat(modelId, ")"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.name
  }, i18nName[locale] || i18nName.en), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.statsTable
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_ClassSkillTooltipContent.default.skillLevel)), /*#__PURE__*/_react.default.createElement("td", null, level)), costMana > 0 && /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_ClassSkillTooltipContent.default.requiredMana)), /*#__PURE__*/_react.default.createElement("td", null, costMana * level * costManaLevelMultiplier)), costStamina > 0 && /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_ClassSkillTooltipContent.default.requiredStamina)), /*#__PURE__*/_react.default.createElement("td", null, costStamina * level * costStaminaLevelMultiplier)), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_ClassSkillTooltipContent.default.requiredLevel)), /*#__PURE__*/_react.default.createElement("td", null, "TODO"), " "), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_ClassSkillTooltipContent.default.target)), " ", /*#__PURE__*/_react.default.createElement("td", null, formatMessage(_ClassSkillTooltipContent.default.friendly)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.currentLevel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.title
  }, formatMessage(_ClassSkillTooltipContent.default.currentLevel)), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.description
  }, i18nDescription[locale] || i18nDescription.en)), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.nextLevel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.title
  }, formatMessage(_ClassSkillTooltipContent.default.nextLevel)), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillTooltipContentModule.default.description
  }, i18nDescription[locale] || i18nDescription.en)));
};

var _default = ClassSkillTooltipContent;
exports.default = _default;